// ## ClientlessAuthNFsm
//
// State machine for AuthN status of Clientless Auth.

'use strict';

var _ = require('./vendor/underscore');
var machina = require('./vendor/machina');
var _logger = require('./logger');
var MVPDPicker = require('./mvpdpicker');


var ClientlessAuthNFsm = machina.Fsm.extend({

	supports : {

	},

	initialize : function () {

		_.bindAll(this, 'onPickerOpened', 'onPickerClosed');

		MVPDPicker.on('opened', this.onPickerOpened);
		MVPDPicker.on('closed', this.onPickerClosed);

		this.on('handling', function (data) {
			_logger.debug('[ClientlessAuthNFsm:' + this.state + '] handling ' + data.inputType, arguments);
		});
		this.on('handled', function (data) {
			_logger.debug('[ClientlessAuthNFsm:' + this.state + '] handled ' + data.inputType, arguments);
		});
		this.on('nohandler', function (data) {
			_logger.debug('[ClientlessAuthNFsm:' + this.state + '] nohandler', data.inputType, arguments);
		});
		this.on('transition', function (data) {
			_logger.debug('[ClientlessAuthNFsm:' + this.state + '] transition from "' + data.fromState + '" to "' + data.toState + '" via "' + data.action + '"', arguments);
		});
		this.on('invalidstate', function () {
			_logger.debug('[ClientlessAuthNFsm:' + this.state + '] invalidstate', arguments);
		});
		this.on('deferred', function () {
			_logger.debug('[ClientlessAuthNFsm:' + this.state + '] deferred', arguments);
		});

	},

	onPickerOpened : function (obj) {
		_logger.debug('PICKER OPENED!');
		this.handle('pickerOpened', obj);
	},
	onPickerClosed : function (obj) {
		_logger.debug('PICKER CLOSED!');
		this.handle('pickerClosed', obj);
	},

	requestCheckAuthN : function () {
		this.authManager._checkAuthN();
	},

	requestGetAuthN : function (redirectUrl) {
		this.authManager._getAuthN(redirectUrl);
	},

	requestLogOut : function () {
		this.authManager._logout();
	},

	initErrors : [],

	getInitErrors : function () {
		return this.initErrors.slice(0);
	},

	initialState : 'Uninitialized',

	states : {

		'Uninitialized' : {
			'init' : 'Initializing'
		},

		'Initializing' : {

			'ready' : function (obj) {
				this.transition('Initialized');
				this.emit('ready', obj);
			},

			'failure' : function (obj) {
				this.transition('InitFailed');
				this.emit('initFailure', obj);
			}

		},

		'InitFailed' : {

		},

		'Initialized' : {

			'authNPass' : function (obj) {
				this._success = obj;
				this.transition('Authenticated');
			},

			'authNFail' : function (obj) {
				this._failure = obj;
				this.transition('Unauthenticated');
			},

			'checkAuthN' : function () {
				this.transition('Authenticating');
				this.requestCheckAuthN();
			},

			'getAuthN' : function (redirectUrl) {
				this.transition('Authenticating');
				this.requestGetAuthN(redirectUrl);
			}

		},

		'Unauthenticated' : {

			_onEnter : function () {
				if (!this._failure) {
					_logger.warn('Unauthenticated but we do not know how/why');
					return;
				}
				this.emit('authNFail', this._failure);
				delete this._failure;
			},

			'authNPass' : function (obj) {
				this._success = obj;
				this.transition('Authenticated');
			},

			'checkAuthN' : function () {
				this.transition('Authenticating');
				this.requestCheckAuthN();
			},

			'getAuthN' : function (redirectUrl) {
				this.transition('Authenticating');
				this.requestGetAuthN(redirectUrl);
			}

		},

		'Authenticating' : {

			'pickerOpened' : 'UserLogIn',

			'authNPass' : function (obj) {
				this._success = obj;
				this.transition('Authenticated');
			},

			'authNFail' : function (obj) {
				this._failure = obj;
				this.transition('Unauthenticated');
			}

		},

		// ignore all calls until picker is closed
		'UserLogIn' : {

			'pickerClosed' : 'Authenticating',

			'authNPass' : function (obj) {
				this._success = obj;
				this.transition('Authenticated');
			},

			'authNFail' : function (obj) {
				this._failure = obj;
				this.transition('Unauthenticated');
			},

			'getAuthN' : function (/*redirectUrl*/) {
				this.deferUntilTransition('Unauthenticated');
				this.authManager.selectProvider(null);
			}

		},

		// ignore all calls until logged out
		'UserLogOut' : {

			_onEnter : function () {
				this.requestLogOut();
			},

			'authNPass' : function (obj) {
				this._success = obj;
				this.transition('Authenticated');
			},

			'authNFail' : function (obj) {
				this._failure = obj;
				this.transition('Unauthenticated');
			}

		},

		'Authenticated' : {

			_onEnter : function () {
				if (!this._success) {
					_logger.warn('Authenticated but we do not know how/why');
					return;
				}
				this.emit('authNPass', this._success);
				delete this._success;
			},

			'authNFail' : function (obj) {
				this._failure = obj;
				this.transition('Unauthenticated');
			},

			'checkAuthN' : function () {
				this.transition('Authenticating');
				this.requestCheckAuthN();
			},

			'getAuthN' : function (/*redirectUrl*/) {
				this.deferUntilTransition('Unauthenticated');
				this.authManager.selectProvider(null);
			},

			'logout' : 'UserLogOut'

		}

	},

	init : function (AuthManager) {
		if (!AuthManager) {
			throw new Error('AuthManager required for init!');
		}

		this.authManager = AuthManager;

		this.handle('init');
	},

	handleInitReady : function (obj) {
		this.handle('ready', obj);
	},

	handleInitFailure : function (obj) {
		this.handle('failure', obj);
	},

	handleAuthNPass : function (obj) {
		this.handle('authNPass', obj);
	},

	handleAuthNFail : function (obj) {
		this.handle('authNFail', obj);
	},

	checkAuthN : function () {
		this.handle('checkAuthN');
	},

	getAuthN : function (redirectUrl) {
		this.handle('getAuthN', redirectUrl);
	},

	logout : function () {
		this.handle('logout');
	}

});


module.exports = ClientlessAuthNFsm;
